import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { EventPage } from "@/pages/EventPage";
import { CitySelect } from "@/pages/CitySelect";
import { EVENTS } from "@/data/events";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CitySelect />} />
            <Route path="/delhi" element={<EventPage event={EVENTS.delhi} />} />
            <Route path="/bangalore" element={<EventPage event={EVENTS.bangalore} />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
